/**
 * Redirects after a successful coupon-code copy on the v2 code interstitial.
 * fragno-interstitial-lockup handles the clipboard write itself and dispatches
 * fragno-interstitial-lockup-copy; this only owns the "redirect 2s after copy"
 * behavior interstitial-clipboard.js used to own. v1 keeps interstitial-clipboard.js
 * for its own .copy-btn path — this is additive, not a replacement of that file.
 */
const REDIRECT_AFTER_COPY_MS = 2000;

// Wrapped so tests can stub the redirect: window.location.assign is
// non-configurable in real browsers, so it can't be stubbed directly.
export const browserNavigation = {
  redirect(url) {
    window.location.assign(url);
  },
};

function handleCopy(event) {
  const host = event.target;
  const redirectUrl = host?.dataset?.redirectUrl;
  if (!redirectUrl) return;
  setTimeout(
    () => browserNavigation.redirect(redirectUrl),
    REDIRECT_AFTER_COPY_MS,
  );
}

export function initInterstitialLockupCopyRedirect() {
  document.addEventListener("fragno-interstitial-lockup-copy", handleCopy);
}

if (typeof document !== "undefined") {
  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initInterstitialLockupCopyRedirect,
    );
  } else {
    initInterstitialLockupCopyRedirect();
  }
}
